export function industrySliderInit($ = jQuery) {
  $(".services-by-industry__carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    // adaptiveHeight: false,
    arrows: true,
    prevArrow: `<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" /></svg></button>`,
    nextArrow: `<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" /></svg></button>`,
    asNavFor: ".services-by-industry__carousel-nav",
  });
  $(".services-by-industry__carousel-nav").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: ".services-by-industry__carousel",
    focusOnSelect: true,
    // centerMode: true,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
}
